import { useMemo } from 'react'
import { EmptyState } from '@/components/ui/EmptyState'
import { SegmentedTabs } from '@/components/ui/SegmentedTabs'
import { ProposalRow } from './ProposalRow'
import type { Proposal } from '@/types/dashboard'

type Filter = 'draft' | 'all'

interface Props {
  proposals: Proposal[]
  filter: Filter
  focusIdx: number
  onFilter: (f: Filter) => void
  onConfirm: (id: string) => void
  onDismiss: (id: string) => void
}

export function ProposalInbox({
  proposals,
  filter,
  focusIdx,
  onFilter,
  onConfirm,
  onDismiss
}: Props) {
  const items = useMemo(
    () => (filter === 'draft' ? proposals.filter((p) => p.status === 'draft') : proposals),
    [proposals, filter]
  )

  return (
    <section className="block tab-block" id="inbox">
      <div className="section-head">
        <div>
          <h2>Proposal inbox</h2>
          <p>
            Dry-run verified drafts. Confirm or dismiss trains trust scores so confidence matches
            what you actually accept.
          </p>
        </div>
        <div className="section-actions">
          <SegmentedTabs
            ariaLabel="Proposal filter"
            value={filter}
            onChange={onFilter}
            tabs={[
              {
                id: 'draft',
                label: 'Drafts',
                count: proposals.filter((p) => p.status === 'draft').length
              },
              { id: 'all', label: 'All', count: proposals.length }
            ]}
          />
        </div>
      </div>
      <div className="stack">
        {!items.length ? (
          <EmptyState
            title="Inbox clear"
            body={`No ${filter === 'draft' ? 'draft ' : ''}proposals. Detect patterns from Automations, then propose a flow.`}
          />
        ) : (
          items.map((p, i) => (
            <ProposalRow
              key={p.id}
              proposal={p}
              focused={i === focusIdx}
              onConfirm={onConfirm}
              onDismiss={onDismiss}
            />
          ))
        )}
      </div>
    </section>
  )
}
